import React, { Fragment, useEffect, useState } from 'react'

import './InformeConciliacion.css'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    faFileImport,
    faCalendarAlt,
    faBuilding,
    faFileExcel,
    faSearch,
    faChartBar,
    faPercentage,
    faList,
} from '@fortawesome/free-solid-svg-icons'

import BotonBack from '../Utiles/BotonBack'
import Subtitulo from '../Utiles/Subtitulo'
import Header from '../Header/Header'

import { withRouter } from 'react-router-dom'

import { getAllSucursales } from '../../Services/sucursalService'
import {
    getReporteConciliacion,
    canExportConciliacionExcel,
    CONCILIACION_UMBRAL_DEFAULT,
    CONCILIACION_UMBRAL_OPTIONS,
    hasRequiredConciliacionFilters,
} from '../../Services/informesService'
import { getExcelReporteConciliacion } from '../../Services/reporteService'

import { formatFechaArgentina } from '../../utils/fechaArgentina'
import {
    canAccessInformes,
    formatConciliacionNumber,
    formatConciliacionPercent,
    conciliacionResultadoClass,
    visibleConciliacionFilas,
} from './informesHub'
import ModalHistorialStock from '../StockSucursal/ModalHistorialStock/ModalHistorialStock'
import {
    informeArticleLabel,
    isInformeRowClickable,
    mapInformeFilaToHistorialProps,
    shouldChangeRouteOnHistorialOpen,
} from './informeConciliacionHistorial'

import Swal from 'sweetalert2'

const InformeConciliacion = ({ history }) => {
    let token = JSON.parse(atob(sessionStorage.getItem('token').split('.')[1]))
    let rol = token.authorities[0]

    const FormatDate = (date) => {
        let day = date.getDate()
        let month = date.getMonth() + 1
        let year = date.getFullYear()

        if (month < 10) month = '0' + month
        if (day < 10) day = '0' + day

        return year + '-' + month + '-' + day
    }

    const [isLoad, setIsLoad] = useState(true)
    const [sucursales, setSucursales] = useState([])
    const [sucursal, setSucursal] = useState(token.sucursal.id)
    const [fechaDesde, setFechaDesde] = useState(FormatDate(new Date()))
    const [fechaHasta, setFechaHasta] = useState(FormatDate(new Date()))
    const [umbral, setUmbral] = useState(CONCILIACION_UMBRAL_DEFAULT)
    const [nombre, setNombre] = useState('')
    const [filas, setFilas] = useState([])
    const [hasGenerated, setHasGenerated] = useState(false)
    const [mostrarTodos, setMostrarTodos] = useState(false)
    const [historialProps, setHistorialProps] = useState(null)

    useEffect(() => {
        if (!canAccessInformes(rol)) history.goBack()
        if (isLoad) {
            getAllSucursales(true, 0, '', 1000)
                .then((res) => {
                    setSucursales(res.data.content)
                })
                .catch((error) => {
                    console.log(error)
                })
            setIsLoad(false)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoad])

    const nombreFilter = () => {
        const trimmed = nombre ? nombre.trim() : ''
        return trimmed ? trimmed : undefined
    }

    const requireFilters = () => {
        if (!hasRequiredConciliacionFilters({ fechaDesde, fechaHasta, sucursal })) {
            Swal.fire({
                toast: true,
                position: 'top',
                title: 'Desde, hasta y sucursal son obligatorios',
                type: 'warning',
                showConfirmButton: false,
                timer: 1800,
            })
            return false
        }
        return true
    }

    const handleGenerarInforme = async () => {
        if (!requireFilters()) return

        try {
            const res = await getReporteConciliacion(
                fechaDesde,
                fechaHasta,
                sucursal,
                umbral,
                nombreFilter()
            )
            const data = res.data || {}
            setFilas(data.filas || [])
            setHasGenerated(true)
            setMostrarTodos(false)
        } catch (error) {
            setHasGenerated(false)
            setFilas([])
            const apiMessage =
                (error.response &&
                    error.response.data &&
                    (error.response.data.mensaje ||
                        error.response.data.message)) ||
                'No se pudo cargar la conciliación de stock'
            Swal.fire({
                toast: true,
                position: 'top',
                title: apiMessage,
                type: 'info',
                showConfirmButton: false,
                timer: 1800,
            })
        }
    }

    const handleExcelReporte = async () => {
        if (!requireFilters()) return
        if (!canExportConciliacionExcel(filas)) return

        try {
            const excel = await getExcelReporteConciliacion(filas, umbral, null)

            const contenido = encodeURI(excel.data)
            let excelWindow = window.open('')
            excelWindow.document.write(
                `<iframe width='100%' height='100%' margin='0px' padding='0px' src='data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${contenido}'>
                </iframe>`
            )
            setTimeout(() => {
                excelWindow.close()
            }, 3000)
        } catch (error) {
            Swal.fire({
                title: 'No hay datos para estas fechas',
                type: 'info',
                showConfirmButton: false,
                timer: 1000,
            })
        }
    }

    const sucursalNombre = () => {
        const found = sucursales.find((s) => String(s.id) === String(sucursal))
        return found ? found.nombre : sucursal
    }

    const excelEnabled = hasGenerated && canExportConciliacionExcel(filas)
    const filasVisibles = visibleConciliacionFilas(filas, mostrarTodos)

    const openLeftoverHistorial = (fila) => {
        if (!isInformeRowClickable(fila)) return
        if (shouldChangeRouteOnHistorialOpen()) return
        setHistorialProps(
            mapInformeFilaToHistorialProps(fila, {
                sucursalId: sucursal,
                from: fechaDesde,
                to: fechaHasta,
            })
        )
    }

    return (
        <Fragment>
            <Header />
            <div className="container-fluid mt-3">
                <div className="alert alert-dismissible alert-secondary d-flex justify-content-between">
                    <BotonBack />
                    <Subtitulo
                        icon={faFileImport}
                        title={'Conciliación'}
                    />
                </div>

                <div className="bg-gris p-3">
                    <div className="d-flex bd-highlight mb-3 flex-wrap">
                        <div className="p-2 bd-highlight">
                            <label htmlFor="inputFechaDesde">Desde *</label>
                            <div className="input-group-prepend">
                                <span
                                    className="input-group-text"
                                    id="inputGroupPrepend"
                                >
                                    <FontAwesomeIcon icon={faCalendarAlt} />
                                </span>
                                <input
                                    type="date"
                                    className="form-control"
                                    id="inputFechaDesde"
                                    name="fechaDesde"
                                    value={fechaDesde}
                                    onChange={(e) =>
                                        setFechaDesde(e.target.value)
                                    }
                                />
                            </div>
                        </div>
                        <div className="p-2 bd-highlight">
                            <label htmlFor="inputFechaHasta">Hasta *</label>
                            <div className="input-group-prepend">
                                <span
                                    className="input-group-text"
                                    id="inputGroupPrepend"
                                >
                                    <FontAwesomeIcon icon={faCalendarAlt} />
                                </span>
                                <input
                                    type="date"
                                    className="form-control"
                                    id="inputFechaHasta"
                                    value={fechaHasta}
                                    name="fechaHasta"
                                    onChange={(e) =>
                                        setFechaHasta(e.target.value)
                                    }
                                />
                            </div>
                        </div>
                        <div className="p-2 bd-highlight">
                            <label htmlFor="inputSucursal">Sucursal *</label>
                            <div className="input-group-prepend">
                                <span
                                    className="input-group-text"
                                    id="inputGroupPrepend"
                                >
                                    <FontAwesomeIcon icon={faBuilding} />
                                </span>
                                <select
                                    id="inputSucursal"
                                    className="custom-select"
                                    name="sucursal"
                                    value={sucursal}
                                    onChange={(e) =>
                                        setSucursal(e.target.value)
                                    }
                                >
                                    {sucursales.map((s, index) => (
                                        <option key={index} value={s.id}>
                                            {s.nombre}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className="p-2 bd-highlight">
                            <label htmlFor="inputUmbral">Umbral *</label>
                            <div className="input-group-prepend">
                                <span
                                    className="input-group-text"
                                    id="inputGroupPrepend"
                                >
                                    <FontAwesomeIcon icon={faPercentage} />
                                </span>
                                <select
                                    id="inputUmbral"
                                    className="custom-select"
                                    name="umbral"
                                    value={umbral}
                                    onChange={(e) =>
                                        setUmbral(Number(e.target.value))
                                    }
                                >
                                    {CONCILIACION_UMBRAL_OPTIONS.map((option) => (
                                        <option key={option} value={option}>
                                            {option}%
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className="p-2 bd-highlight">
                            <label htmlFor="inputNombre">Nombre</label>
                            <div className="input-group-prepend">
                                <span
                                    className="input-group-text"
                                    id="inputGroupPrepend"
                                >
                                    <FontAwesomeIcon icon={faSearch} />
                                </span>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="inputNombre"
                                    name="nombre"
                                    placeholder="Buscar por nombre"
                                    value={nombre}
                                    onChange={(e) => setNombre(e.target.value)}
                                />
                            </div>
                        </div>
                        <div
                            className="ms-auto p-2 bd-highlight"
                            style={{ marginTop: 20 }}
                        >
                            <button
                                className="btn btn-outline-info btn-lg mr-2"
                                onClick={handleGenerarInforme}
                            >
                                <FontAwesomeIcon icon={faChartBar} /> Generar
                                Reporte
                            </button>
                            <button
                                className="btn btn-outline-success btn-lg"
                                onClick={handleExcelReporte}
                                disabled={!excelEnabled}
                                title={
                                    !hasGenerated
                                        ? 'Generá el reporte primero'
                                        : !canExportConciliacionExcel(filas)
                                          ? 'Sin datos para exportar'
                                          : 'Exportar Excel'
                                }
                            >
                                <FontAwesomeIcon icon={faFileExcel} /> Excel
                            </button>
                        </div>
                    </div>
                    {hasGenerated && (
                        <p className="mb-0 text-muted">
                            Período:{' '}
                            {formatFechaArgentina(fechaDesde)} —{' '}
                            {formatFechaArgentina(fechaHasta)} · Sucursal:{' '}
                            {sucursalNombre()} · Umbral: {umbral}%
                        </p>
                    )}
                </div>

                {hasGenerated && (
                    <Fragment>
                        <br />
                        <div className="bg-gris p-3">
                            <div className="d-flex justify-content-between align-items-center flex-wrap mb-3">
                                <h5 className="mb-0">Conciliación de stock</h5>
                                <div className="custom-control custom-switch">
                                    <input
                                        type="checkbox"
                                        className="custom-control-input"
                                        id="switchMostrarTodos"
                                        checked={mostrarTodos}
                                        onChange={(e) =>
                                            setMostrarTodos(e.target.checked)
                                        }
                                    />
                                    <label
                                        className="custom-control-label"
                                        htmlFor="switchMostrarTodos"
                                    >
                                        Mostrar todos ({filas.length})
                                    </label>
                                </div>
                            </div>
                            <p className="text-muted mb-2">
                                {mostrarTodos
                                    ? `Mostrando ${filasVisibles.length} artículos`
                                    : `Mostrando ${filasVisibles.length} a revisar de ${filas.length}`}
                            </p>
                            <div className="informe-conciliacion-table-wrap">
                                <table className="table table-striped mt-3 text-center informe-conciliacion-table">
                                    <thead>
                                        <tr>
                                            <th scope="col">Artículo</th>
                                            <th scope="col">Inicial</th>
                                            <th scope="col">Ingresos</th>
                                            <th scope="col">Ventas</th>
                                            <th scope="col">Final</th>
                                            <th scope="col">Diferencia</th>
                                            <th scope="col">Diferencia %</th>
                                            <th scope="col">Resultado</th>
                                            <th scope="col">Movimientos</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filas.length === 0 ? (
                                            <tr>
                                                <td colSpan={9}>
                                                    Sin artículos para los
                                                    filtros seleccionados
                                                </td>
                                            </tr>
                                        ) : filasVisibles.length === 0 ? (
                                            <tr>
                                                <td colSpan={9}>
                                                    No hay artículos a revisar.
                                                    Activá Mostrar todos para
                                                    ver el universo completo.
                                                </td>
                                            </tr>
                                        ) : (
                                            filasVisibles.map((fila) => {
                                                const puedeVerMovimiento =
                                                    isInformeRowClickable(fila)
                                                return (
                                                <tr key={fila.articuloId}>
                                                    <td>
                                                        {informeArticleLabel(
                                                            fila
                                                        )}
                                                    </td>
                                                    <td>
                                                        {formatConciliacionNumber(
                                                            fila.inicial
                                                        )}
                                                    </td>
                                                    <td>
                                                        {formatConciliacionNumber(
                                                            fila.ingresos
                                                        )}
                                                    </td>
                                                    <td>
                                                        {formatConciliacionNumber(
                                                            fila.ventas
                                                        )}
                                                    </td>
                                                    <td>
                                                        {formatConciliacionNumber(
                                                            fila.final
                                                        )}
                                                    </td>
                                                    <td>
                                                        {formatConciliacionNumber(
                                                            fila.diferencia
                                                        )}
                                                    </td>
                                                    <td>
                                                        {formatConciliacionPercent(
                                                            fila.diferenciaPorcentaje
                                                        )}
                                                    </td>
                                                    <td
                                                        className={conciliacionResultadoClass(
                                                            fila.resultado
                                                        )}
                                                    >
                                                        {fila.resultado}
                                                    </td>
                                                    <td>
                                                        <button
                                                            type="button"
                                                            className="btn btn-outline-info btn-sm"
                                                            data-toggle={
                                                                puedeVerMovimiento
                                                                    ? 'modal'
                                                                    : undefined
                                                            }
                                                            data-target={
                                                                puedeVerMovimiento
                                                                    ? '#modalHistorialStockInforme'
                                                                    : undefined
                                                            }
                                                            disabled={
                                                                !puedeVerMovimiento
                                                            }
                                                            title={
                                                                puedeVerMovimiento
                                                                    ? 'Ver movimientos que explican la diferencia'
                                                                    : 'Solo disponible cuando el resultado es A revisar'
                                                            }
                                                            onClick={() =>
                                                                openLeftoverHistorial(
                                                                    fila
                                                                )
                                                            }
                                                        >
                                                            <FontAwesomeIcon
                                                                icon={faList}
                                                            />{' '}
                                                            Ver movimiento
                                                        </button>
                                                    </td>
                                                </tr>
                                                )
                                            })
                                        )}
                                    </tbody>
                                </table>
                            </div>
                            <ModalHistorialStock
                                articuloId=""
                                articuloNombre=""
                                sucursalId={sucursal}
                                headerLabel="Diferencia"
                                headerValue=""
                                subtitleLabel="Final"
                                subtitleValue=""
                                trigger="name"
                                {...(historialProps || {})}
                            />
                        </div>
                    </Fragment>
                )}
            </div>
        </Fragment>
    )
}

export default withRouter(InformeConciliacion)
